"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskState = exports.defaultAutoAIProvider = exports.autoAIProviderOptions = exports.autoAIProvider = void 0;
exports.autoAIProvider = {
    OpenAI: "OpenAI",
    DeepSeek: "DeepSeek",
    Anthropic: "Anthropic",
    Google: "Google",
};
exports.autoAIProviderOptions = Object.values(exports.autoAIProvider);
exports.defaultAutoAIProvider = exports.autoAIProvider.OpenAI;
var TaskState;
(function (TaskState) {
    TaskState[TaskState["Created"] = 0] = "Created";
    TaskState[TaskState["Pending"] = 1] = "Pending";
    TaskState[TaskState["Done"] = 2] = "Done";
    TaskState[TaskState["Error"] = 3] = "Error";
})(TaskState || (exports.TaskState = TaskState = {}));
